var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showCardStack)?_c('CardsStack',{attrs:{"cards":_vm.visibleCards},on:{"cardAccepted":_vm.handleCardAccepted,"cardRejected":_vm.handleCardRejected,"cardSkipped":_vm.handleCardSkipped,"hideCard":_vm.removeCardFromDeck}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }